import { imgUrl } from "@/lib/api";
import { ratioOf } from "@/lib/aspects";

export const FramedImage = ({ src, alt = "", aspect, fallback = "landscape", className = "", imgClassName = "", testid, clip }) => {
  const ratio = ratioOf(aspect, fallback);
  if (!ratio) return <img data-testid={testid} src={imgUrl(src)} alt={alt} className={`w-full h-auto block ${imgClassName}`} />;
  return (
    <div className={`overflow-hidden ${className}`} style={{ aspectRatio: ratio, clipPath: clip }}>
      <img data-testid={testid} src={imgUrl(src)} alt={alt} className={`w-full h-full object-cover ${imgClassName}`} />
    </div>
  );
};
